import ValuesBar from 'components/ValuesBar/ValuesBar';
import { StyledCell } from '../../../../../../ResourceAllocationOverview/JiraStats/useTableRows/Row.style';
import {
  ISSUE_STATUSES,
  LINB_ISSUE_STATES
} from '../../../../state/issue.statuses';
import styled from 'styled-components';
import {
  StyledValuesBar,
  StyledValuesBarItem
} from 'components/ValuesBar/ValuesBar.style';

const StyledProgressionCell = styled(StyledCell)`
  display: flex;
  justify-content: space-around;
  & ${StyledValuesBar} {
    margin-left: 1rem;
    width: 70%;

    & ${StyledValuesBarItem} {
      height: 1.5rem;
    }
  }
`;

const ProgressionCell = ({ progress }) => {
  const created = progress?.[LINB_ISSUE_STATES.CREATED];
  const wip = progress?.[LINB_ISSUE_STATES.WIP];
  const done = progress?.[LINB_ISSUE_STATES.DONE];
  const totalProgress = Math.round(progress?.progress);

  const stackingBarData = [
    {
      name: 'Done',
      value: done,
      color: ISSUE_STATUSES[LINB_ISSUE_STATES.DONE].color
    },
    {
      name: 'In-Progress',
      value: wip,
      color: ISSUE_STATUSES[LINB_ISSUE_STATES.WIP].color
    },
    {
      name: 'To Do',
      value: created,
      color: ISSUE_STATUSES[LINB_ISSUE_STATES.CREATED].color
    }
  ];

  return (
    <StyledProgressionCell>
      {totalProgress}%
      <ValuesBar data={stackingBarData} withPercents withTooltip />
    </StyledProgressionCell>
  );
};

export default ProgressionCell;
